import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";

import PopupAHSF from "../../../Components/PopupAHSF";
import TableAHSF from "../../../Components/TableAHSF";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
const TransferBetweenEvaluatorTable = (props) => {
  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks.arrayDataCheckBoks["SubtasksList"]
  );
  const UserInfo = useSelector((state) => state.UserInfo.UserInfo);

  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const [popUpBodyAddStatus, setpopUpBodyAddStatus] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];

  const RequestAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: "رقم الطلب",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "applicantfullName",
      ShowStatus: true,
      NmaeColumn: "الاسم الكامل",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "fieldName",
      ShowStatus: true,
      NmaeColumn: "الحقل",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "subjectName",
      ShowStatus: true,
      NmaeColumn: "الموضوع",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "subTaskMark",
      ShowStatus: true,
      NmaeColumn: "علامة التحكيم",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "shortList",
      ShowStatus: true,
      NmaeColumn: "هل الطلب ضمن القائمة القصيرة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "reasonDescription",
      ShowStatus: true,
      NmaeColumn: "السبب",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "subTaskStatus",
      ShowStatus: true,
      NmaeColumn: "حالة التحكيم",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "",
        keyValueName: "",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  console.log(arrayDataCheckBoks, "ssssssdwdwdddd");

  const RequestsManagerBtns = [];

  const RequestsManagerColumns = [];
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const OtherMainBtns = [{}];

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const shouldDisableFields = "";
  useEffect(() => {
    dispatch(setRefreshTable({ tableId: "EvaluatorTransfer" }));
  }, [props.DropDownFrom, props.fields, props.subject]);
  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        tableId="EvaluatorTransfer"
        uniqueValue={"taskId"}
        valueButtonAction={"taskId"}
        URL={`api/Evaluator/GetSubTasksByEvalutorId2`}
        // UrlBody={{ userGUID: UserInfo?.UserId }}
        UrlBody={{
          userGUID: props.DropDownFrom,
          fieldId: props.fields,
          subjectId: props.subject,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"الطلبات لدى المحكم"}
        selectRowNumber={true}
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        uniqeKeyName={"subTaskId"}
        dataRedux={arrayDataCheckBoks}
        uniqeKeyNameRedux={"SubtasksList"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={true}
        checkBoksColumName="تحديد الكل"
        nameColumAction=""
        total={false}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        trueText="نعم"
        falseText="لا"
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
          />
        }
      />
    </>
  );
};
export default TransferBetweenEvaluatorTable;
